import { apiRequest } from './api';

export function getFaqs() {
  return apiRequest('/api/faqs', {
    method: 'GET',
  });
}
